import { useEffect, useRef } from '@wordpress/element';

/**
 * Sync compiledCss into block attributes via setAttributes.
 * Avoids redundant updates by remembering the last value.
 *
 * @param {string} compiledCss
 * @param {Function} setAttributes
 */
export default function useSyncCompiledCss( compiledCss, setAttributes ) {
	const prevRef = useRef();

	useEffect( () => {
		// Guard: only run inside a React render flow and when setAttributes is callable
		if ( typeof setAttributes !== 'function' ) return;
		if ( ! compiledCss ) return;
		if ( prevRef.current === compiledCss ) return;

		setAttributes( { compiledCss } );
		prevRef.current = compiledCss;
	}, [ compiledCss, setAttributes ] );
}
